import { CustomerEntryController } from './customerEntry.controller';
import template from './customerEntry.html';

export const customerEntryComponent = {
  name: 'customerEntryComponent',
  restrict: 'E',
  template,
  controller: CustomerEntryController,
  controllerAs: 'vm',
  bindings: {
    isStateAvailable: '<'
  }
};
